// extracted by mini-css-extract-plugin
module.exports = {"protocolModal":"ProtocolModal_style_protocolModal__1rT1u","content":"ProtocolModal_style_content__322bP"};